import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {GrievanceService} from '../../_services/grievance.service';
import {Grievance, Item, Profile} from '../../_services/_modals/grievance.modal';
import {AppEventService} from '../../../common/_services/event-broadcaster.service';
import {GrievanceComponent} from '../grievance/grievance.component';
import {MatPaginator, MatTableDataSource, PageEvent} from '@angular/material';
import {element} from 'protractor';
import {assertNumber} from '@angular/core/src/render3/assert';
import {MatSort} from '@angular/material/sort';
import {FormGroup} from '@angular/forms';
import {HttpService} from '../../../common/_services/http.service';

@Component({
    selector: 'app-grievance-list',
    templateUrl: './grievance-list.component.html',
    styleUrls: ['./grievance-list.component.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class GrievanceListComponent implements OnInit {
    dataSource: any;
    dataSource2: any;
    @ViewChild(MatSort, {read: MatSort}) sort: MatSort;
    @ViewChild('unmoderated', {read: MatPaginator}) paginator: MatPaginator;
    @ViewChild('moderateuser', {read: MatPaginator}) paginator1: MatPaginator;

    @Input()
    mod_callerid: string;
    @Input()
    ai_id: number;
    @Input()
    public rejectionReason: any;
    tags = [];
    displayedColumns: string[] = ['callerid', 'title'];
    expandedElement: Grievance;
    @Input()
    items: Grievance[] = [];
    itemsCount: number;
    color = 'primary';
    value = 50;
    is_spinner_visible = false;
    constructor() {}
    ngOnInit() {
        this.itemsCount = this.items.length;
    }

    tabtoggle() {}

}


